import { useEffect, useState } from "react";
import styles from "./Cupoes.module.css";
import { Link } from "react-router-dom";
import load from "../../../../Images/loading.gif";
import CreateModal from "./CreateModal/CreateModal";

function Cupoes({ user }) {
    const [cupoes, setCupoes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [modalOpen, setModalOpen] = useState(false);

        const fetchCupoes = async () => {
            try {
                const response = await fetch("https://eclipsebots.com/api/coupons/get", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch coupons");
                }

                const data = await response.json();

                setCupoes(data);
            } catch (error) {
                console.error("Erro ao buscar cupoões:", error);
                setCupoes([]);
            } finally {
                setLoading(false);
            }
        };

    useEffect(() => {
        fetchCupoes();
    }, []);


    const handleCreatePlan = async (cupom) => {
        await fetch("https://eclipsebots.com/api/coupons/create", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({...cupom, authorId: user.id})
        });
        fetchCupoes();
    };

    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    const filteredCoupons = cupoes.filter(coupon =>
        coupon.coupon_code.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className={styles.coupons}>
            <CreateModal isOpen={modalOpen} onCreate={handleCreatePlan} onClose={() => setModalOpen(false)} />
            <div className={styles.header}>
                <div className={styles.input}>
                    <input
                        type="text"
                        placeholder="Procurar por nome de cupão..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>
                <div className={styles.button}>
                    <button onClick={() => setModalOpen(true)}>Criar Cupão</button>
                </div>
            </div>
            {cupoes.length === 0 ? (
                <div className={styles.noData}>
                    Não existe nenhuma cupão de momento.
                </div>
            ) : (
                <div className={styles.couponcontent}>

                    {filteredCoupons.length === 0 && (
                        <div className={styles.noData}>
                            Não existe nenhum cupão com esses dados.
                        </div>
                    )}
                    <div className={styles.overflow}>
                        {filteredCoupons.map((coupon, index) => {
                            const isFirst = index === 0;
                            const isLast = index === cupoes.length - 1;

                            return (
                                <Link to={`${coupon.coupon_code}`}>
                                    <div key={coupon.coupon_code} className={`${styles.coupon} ${isFirst ? styles.first : ""} ${isLast ? styles.last : ""}`}>
                                        <div className={`${styles.name} ${styles.imagem}`}>
                                            {coupon.coupon_code}
                                        </div>
                                    </div>
                                </Link>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Cupoes;